<script>

import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
//import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Add New Channel",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Add New Channel",

            channelpartnerlist: [],
            countryList: [],
            name: '',
            branch_code: '',
            pausedFor5Seconds: false,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },       

        create_channel(e)
        {
          this.pausedFor5Seconds = true;
            this.ButtonSeen=true;
            e.preventDefault()
            
            const posting_ = {                
                name: this.name,
                country: 1,
                status:0,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'chanel/create', posting_)
            .then(response => {
                if (response) {
                  this.ButtonSeen=false; 
                  setTimeout(() => {this.pausedFor5Seconds= false;}, 40*1000);
                  alert(response.data.msj); 

                  this.$router.push({ name: 'channel-partner' });

                }
                else{
                    this.ButtonSeen=false;
                    console.log('tak ok');
                }
            });
        },

        //raw data----------------------------------------------------------
        get_channel_partner(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'channelpartner/raw_data')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.channelpartnerlist = response.data;
                    console.log(this.channelpartnerlist);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_country(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'finco/raw_data_country')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.countryList = response.data;
                    console.log(this.countryList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        //raw data----------------------------------------------------------
    },

    components: {
        Layout,
        PageHeader, 
    },

    mounted() {       
        this.get_channel_partner();
        this.get_country();         
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-7">
        <div class="card">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <h4><span class="badge badge-soft-primary badge-border"><i class="ri-information-line align-middle me-1"></i>Channel Information</span></h4>
            </div>
          </div>
          <div class="card-body">
            <div class="live-preview">
              <form @submit="create_channel">
                <div class="row mb-3">
                  <div class="col-lg-3">
                    <label for="branch_name" class="form-label">Name</label>
                  </div>
                  <div class="col-lg-9">
                    <input v-model='name' type="text" class="form-control" id="branch_name" />
                  </div>
                </div>
 
               
                <hr class="my-4 text-muted">
                <div class="text-end col-lg-12">
                  <a @click="$router.go(-1)" class="btn btn-success">Back</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button type="submit" class="btn btn-primary" :disabled="pausedFor5Seconds">Create</button>
                </div>
              </form>
            </div>
          </div>
        </div>        
      </div>


    </div>
  </Layout>
</template>
